import React from "react";
import comingsoon from "./assets/comingsoon.png"
import encours from "./assets/encours.png"
class EnTravaux extends React.Component
{

    render()
    {

        
        return (
            <div style={{textAlign:"center"}}>
            <h5>{this.props.title}</h5>
            <img src={this.props.encours?encours:comingsoon} width={32} height={32}/>
            </div>
        )
    }

}
export default EnTravaux;